<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid>
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            {{ item_previa.nombre }}
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-2">
                        <h3>
                            <table class="table table-sm table-striped table-bordered" style="font-size: 14px;">
                                <thead>
                                    <tr>
                                        <th style="width: 85%;">
                                            Sucursal
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Existencia
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in listado" :key="index">
                                        <td>
                                            {{ item.sucursal }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.existencia }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </h3>
                    </div>
                </b-row>
            </b-container>

        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'VistaPrevia',
        props: ['item_previa'],
        computed: {
            ...mapState(['id_empresa_seleccionada'])
        },
        data() {
            return {
                listado: []
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async obtener_info() {
                let f = {
                    api: `articulos/c/existencia?codigo=${this.item_previa.codigo}&empresa=${this.id_empresa_seleccionada}`
                }

                let r = await this.obtener_data(f)
                this.listado = r
            },
            ...mapActions(['obtener_data'])
        },
        mounted() {
            this.obtener_info()
        },
    }
</script>

<style></style>